import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";

export default function ProtectIncome() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            width="100%"
            height="100%"
            strokeWidth={0}
            fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)"
          />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl  gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Protect Your Income
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Akiba Endowment Plan
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                The Britam Akiba Plan is an Endowment product ( i.e designed to
                pay benefits after an agreed period) that provides you with a
                systematic savings vehicle to provide for a wide range of short
                and medium-term goals
              </p>
              <h5>
                <strong>Why Britam Akiba Endowment Plan</strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
                  It offers higher returns compared to other average insurance
                  savings products.
                </li>
                <li>
                  It is flexible allowing you the option for lower policy terms
                  between 5 and 12 Years and affordable.
                </li>
                <li>
                  It allows for a higher entry age of up 65 compared to most
                  endowment products which are normally set at 55 years.
                </li>
                <li>
                  Akiba pays a lump sum at maturity. In the unfortunate event of
                  death before maturity, the free waiver of premium guarantees
                  the payment of the maturity benefit.{" "}
                </li>
                <li>
                  It has an optional death benefit rider, which pays the sum
                  assured in the event of death of the assured life.
                </li>
                <li>
                  It allows a surrender benefit from the end of 25th policy
                  month.
                </li>
              </ul>
              <h5 className="mt-8">
                <strong>Eligibility</strong>
              </h5>

              <p className="">
                You are eligible to apply for the Britam Akiba Endowment Plan if
                you are between age 18 and 65 and a Kenyan citizen. You can
                apply by completing the Britam Akiba Endowment Plan application
                form for cover.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-2xl mt-20 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Protect Your Income
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Dhamana Plan
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                Dhamana is a Life Assurance product designed to offer you a
                platform to save while enjoying a guaranteed investment and life
                insurance.
              </p>
              <h5></h5>
              <ul className="list-disc list-inside">
                <li>
                  Dhamana guarantees an investment rate of return of 5% for
                  continuing policies.
                </li>
                <li>
                  Dhamana is affordable with a minimum premium of Kes 1000 per
                  month with no restrictions on the maximum.
                </li>
                <li>The maximum entry age is 60 years. </li>
                <li>
                  In the unfortunate event of the policy holder’s death, Dhamana
                  will pay out a death benefit to the beneficiaries.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-2xl mt-20 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Protect Your Income
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Family Income Solution
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                The Britam family Income is a solution that provides financial
                support to your family in the unfortunate event of your untimely
                death, Britam will pay your chosen beneficiary(s) a monthly
                income equal to your chosen sum assured for the rest of your
                chosen benefit period.{" "}
              </p>
              <h5>
                <strong>About Britam Family Income Solution</strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
                  One selects the sum assured and a benefit period at the onset
                  of the policy.{" "}
                </li>
                <li>
                  The sum assured is the monthly amount that will be payable to
                  the beneficiaries in the event of the life assured’s death.
                </li>
                <li>
                  The benefit payments will continue for your chosen benefit
                  period i.e. 3, 5 or 10 years.
                </li>
                <li>
                  The amount of premium you pay will depend on your age, the
                  amount of the sum assured and the benefit period.
                </li>
                <li>
                  The premiums are very affordable and are payable either
                  monthly, quarterly, semiannually or annually as you desire.
                </li>
                <li>
                  Various premium payment options are available e.g. Employer
                  salary check-off, direct debit, personal cheques or mobile
                  money transfer.
                </li>
                <li>
                  In the unfortunate even of your untimely death, Britam will
                  pay your chosen beneficiary(s) a monthly income equal to your
                  chosen sum assured for the rest of your chosen benefit period.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto grid max-w-2xl mt-20 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
          <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
            <div className="lg:pr-4">
              <div className="lg:max-w-lg">
                <p className="text-base font-semibold leading-7 text-indigo-600">
                  Protect Your Income
                </p>
                <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Money Back Extra Cash
                </h1>
              </div>
            </div>
          </div>

          <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
            <div className="lg:pr-4">
              <div className=" text-base leading-7 text-gray-700 ">
                <p>
                  The money back extra cash policy offers an attractive
                  combination of life assurance and savings plans tailored to
                  better meet your needs. There are different policies and terms
                  available.
                </p>
                <p>
                  Cash bonuses are paid out every four or five years depending
                  on the policy selected. With personal accident, the full sum
                  assured is paid in the event of death and double sum is
                  assured if death was accidental. There is last expense cover
                  as well as tax benefits.
                </p>
                <h5></h5>
                <ul className="list-disc list-inside">
                  <li>
                    <b>Guaranteed cash bonuses </b>- Guaranteed cash bonuses of
                    20% or 25% are paid after every four or five years
                    respectively depending on the policy term.
                  </li>
                  <li>
                    <b>Maturity benefit</b> - The policy pays 100% of the sum
                    assured on expiry of the selected term regardless of any
                    previous benefit.
                  </li>
                  <li>
                    <b>Tax benefit</b> - An insurance tax relief amounting to
                    15% of the premiums paid (subject to a maximum of Kshs.
                    5,000 per month) is available. The full amount payable at
                    the maturity of the policy is tax free.
                  </li>
                  <li>
                    <b>Disability benefit</b> - In the event of total and
                    permanent disability through sickness or accident, the sum
                    assured will be paid in 24 equal monthly installments.
                    Britam will pay premiums for you until the policy matures.
                  </li>
                  <li>
                    <b>Death benefit</b> - In the event of death, the full sum
                    assured is paid out. If death is accidental, double sum
                    assured is paid. The policy terminates on death.
                  </li>
                  <li>
                    <b>Injury (Disbursement) benefit</b> - In the event of loss
                    of one limb or one eye through an accident, Britam will pay
                    50% of the sum assured. In case of loss of two limbs or both
                    eyes, a benefit of 100% of the sum assured will be paid and
                    Britam will pay all future premiums.
                  </li>
                </ul>

                <h5 className="mt-8">
                  <strong>Monthly Premium</strong>
                </h5>
                <p>
                  Discounts are available for policies paying higher premiums as
                  shown in the table below.
                </p>

                <table>
                    <thead>
                        <tr>
                            <th className="">Monthly Premium</th>
                            <th className="px-2">Discount Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>0 - 4999</td>
                            <td>0.00%</td>
                        </tr>
                        <tr>
                            <td>5,000 – 9,999</td>
                            <td>5.00%</td>
                        </tr>
                        <tr>
                            <td>10,000 – 19,999</td>
                            <td>10.00%</td>
                        </tr>
                        <tr>
                            <td>20,000 – 29,999</td>
                            <td>	12.50%</td>
                        </tr>
                        <tr>
                            <td>30,000 and above</td>
                            <td>	15.00%</td>
                        </tr>
                    </tbody>
                </table>





              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
